import { defineComponent as _defineComponent } from 'vue'
import { language, reportIndexPvUvAndTimeCost } from '@tencent/ppd-base-libs';
import { to } from '@tencent/wphk-base-utils';
import { onMounted } from 'vue';
import { ERouterName } from './config';
import { setUpWeixinInit } from './utils/cache-setup-wx';
import { getUrlParamByKey, UrlParamKey } from './utils/url-params-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const lang = language.getLanguage();

onMounted(async () => {
  reportIndexPvUvAndTimeCost();
  // 是否非香港钱包用户，非香港钱包用户是没有登录态的，如果
  const isNotHkUser = getUrlParamByKey(UrlParamKey.isNotHkUser);
  // 是否目标页面为中转页
  const isRedirectToThirdPage = getUrlParamByKey(UrlParamKey.page) === ERouterName.thirdmpredirect;
  // 如果非香港钱包用户访问中转页的话 就不调用需要登录态的jsapi初始化，应该是用不用登录态的jsapi
  const isSkipLogin: boolean = Boolean(isNotHkUser) && Boolean(isRedirectToThirdPage);

  await to(setUpWeixinInit(isSkipLogin));
  console.log('setUpWeixinInit');
});


return { __sfc: true,lang }
}

})